module.exports = __webpack_public_path__ + "img/ic_32_stepper_down.ae1b8aa1.svg";